import Vue from 'vue'

// state
const state = {
    mini: false,
    drawer: true,
    luz: true,
    temporal: false,
    layout: 'sinmenu',
    movil: false,
    showAvatar: false
};
// mutations
const mutations = {
    setMini(state, estado) {
        state.mini = estado;
    },
    setDrawer(state, estado) {
        state.drawer = estado;
    },
    drawerToggle(state) {
        state.drawer = !state.drawer
    },
    setLuz(state, estado) {
        state.luz = estado;
    },
    setTemporal(state, estado) {
        state.temporal = estado;
    },
    setLayout(state, layout) {
        state.layout = layout;
    },
    setMovil(state, estado) {
        state.movil = estado;
    },
    toggleShowAvatar(state) {
        state.showAvatar = !state.showAvatar
    },
};
// actions
const actions = {
    setTemporal({commit}, value) {
        commit('setTemporal', value);
    },
    setLuz({commit}, value) {
        commit('setLuz', value);
    },
    setDrawer({commit}, value) {
        commit('setDrawer', value);
    },
    drawerToggle({commit}) {
        commit('drawerToggle');
    },
    setLayout({commit}, value) {
        commit('setLayout', value);
    },
    setMovil({commit}, value) {
        commit('setMovil', value);
    },
    toggleShowAvatar({commit}) {
        commit('toggleShowAvatar');
    },
};

// getters
const getters = {
    luz: state => state.luz,
    temporal: state => state.temporal,
    drawer: state => state.drawer,
    navBarMini: state => state.mini,
    layout: state => state.layout,
    movil: state => state.movil,
    showAvatar: state => state.showAvatar,
}

/*
|--------------------------------------------------------------------------
| Export the module
|--------------------------------------------------------------------------
*/
export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}


// WEBPACK FOOTER //
// ./resources/assets/js/store/modules/config.js